<template>
	<div class="role-auth-wrap">
		<!-- 选择角色 -->
		<el-row :gutter="20">
			<el-col :span="6">
				<el-select v-model="currentRoleId" placeholder="请选择角色" @change="handleRoleChange" style="width: 100%">
					<el-option v-for="item in roleList" :key="item.id" :label="item.roleName"
						:value="item.id"></el-option>
				</el-select>
			</el-col>
			<el-col :span="4">
				<el-button type="primary" @click="saveAuth">保存授权</el-button>
			</el-col>
		</el-row>

		<!-- 菜单授权树 -->
		<el-tree ref="menuTree" class="mt-20" :data="treeData" :props="treeProps" node-key="menuCode" show-checkbox
			check-strictly :default-checked-keys="checkedKeys" default-expand-all></el-tree>

		<!-- 已授权菜单列表 -->
		<div class="mt-20">
			<h4>当前角色已授权菜单列表</h4>
			<el-table :data="authList" border style="width: 100%">
				<el-table-column prop="menuName" label="菜单名称" align="center" />
				<el-table-column prop="menuCode" label="菜单编码" align="center" />
				<el-table-column prop="platform" label="所属平台" align="center" />
			</el-table>
		</div>
	</div>
</template>

<script>
	import {
		getRoleList,
		getMenuTree,
		getChecked,
		authRole
	} from './memu.js'
	export default {
		name: 'RoleAuth',
		data() {
			return {
				roleList: [],
				currentRoleId: '',
				treeData: [],
				treeProps: {
					label: 'menuName',
					children: 'children'
				},
				checkedKeys: [],
				authList: []
			}
		},
		mounted() {
			this.initData()
		},
		methods: {
			// 初始化角色、菜单树
			async initData() {
				const roleRes = await getRoleList()
				this.roleList = roleRes.data.data
			},
			async toMenuTree(platform) {
				const menuRes = await getMenuTree(platform)
				this.treeData = menuRes.data.data
			},
			// 切换角色，回显已授权菜单
			async handleRoleChange() {
				if (!this.currentRoleId) return
				console.log(this.currentRoleId)
				var platform = this.roleList.filter(v => v.id == this.currentRoleId)[0].platform

				// this.treeData=[]
				this.toMenuTree(platform)

				const res = await getChecked(this.currentRoleId)
				this.checkedKeys = res.data.data
				// 拼接已授权列表
				this.getAuthList()
			},
			// 组装已授权菜单列表
			async getAuthList() {
				const res = await getChecked(this.currentRoleId)
				this.checkedKeys = res.data.data
				const list = []
				const loop = (arr) => {
					arr.forEach(item => {
						if (this.checkedKeys.includes(item.menuCode)) {
							list.push(item)
						}
						if (item.children && item.children.length) {
							loop(item.children)
						}
					})
				}
				loop(this.treeData)
				this.authList = list
			},
			// 保存授权
			async saveAuth() {
				if (!this.currentRoleId) {
					this.$message.warning('请先选择角色')
					return
				}
				// 获取全选 + 半选节点
				const allKeys = this.$refs.menuTree.getCheckedKeys()
				const halfKeys = this.$refs.menuTree.getHalfCheckedKeys()
				const newMenuCodeList = [...allKeys, ...halfKeys]

				await authRole(this.currentRoleId, newMenuCodeList)
				this.$message.success('授权保存成功')
				this.getAuthList()
			}
		}
	}
</script>

<style scoped>
	.mt-20 {
		margin-top: 20px;
	}
</style>